package com.example.readingnotes.domain.repository

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.util.Result

data class PaginatedPosts(
    val posts: List<Post>,
    val currentPage: Int,
    val totalPages: Int,
    val hasMore: Boolean,
)

interface PostRepository {
    suspend fun getPosts(page: Int = 1, pageSize: Int = 20): Result<List<Post>>

    suspend fun getPostsWithPagination(page: Int = 1, pageSize: Int = 20): Result<PaginatedPosts>

    suspend fun getPost(id: Int): Result<Post>

    suspend fun createPost(
        title: String,
        contentMarkdown: String,
        imageUrl: String? = null, // Keep for backward compatibility
        imageIds: List<Int> = emptyList(),
    ): Result<Post>

    // New methods for admin operations
    suspend fun updatePost(
        id: Int,
        title: String? = null,
        contentMarkdown: String? = null,
        imageUrl: String? = null, // Keep for backward compatibility
        imageIds: List<Int>? = null, // null means no change to imageIds
        status: String? = null,
        totpCode: String? = null,
    ): Result<Post>

    suspend fun deletePost(id: Int, totpCode: String? = null): Result<Unit>

    suspend fun updatePostStatus(id: Int, status: String, totpCode: String? = null): Result<Post>

    // Search methods
    suspend fun searchPosts(
        query: String,
        page: Int = 1,
        pageSize: Int = 20,
        status: String? = null,
    ): Result<SearchResult>
}

data class SearchResult(
    val results: List<Post>,
    val pagination: SearchPagination,
    val query: String,
)

data class SearchPagination(
    val page: Int,
    val pageSize: Int,
    val total: Int,
    val totalPages: Int,
)
